// Web-only strings for the 2026-10-18 parity extras (PARITY P295–P346): «Copiar nombre», the
// attention title, the thread window, the diagnostics panel (the Mac's labels, which it draws in
// Spanish only — here in both languages), the paste-table note. BOTH languages.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.extras.attention': 'Te mencionaron',
    'web.extras.copyName': 'Copiar nombre',
    'web.extras.nameCopied': 'Nombre copiado',
    'web.extras.usernameCopied': '@usuario copiado',
    'web.extras.tableCopied': 'Tabla copiada',
    'web.extras.copyFailed': 'No se pudo copiar.',
    'web.extras.threadWindow.blocked': 'El navegador no dejó abrir la ventana. Permite las ventanas emergentes de Satori Chat.',
    'web.extras.threadWindow.hostGone': 'La ventana principal de Satori Chat se cerró o se recargó. Cierra esta ventana y abre el hilo otra vez.',
    'web.extras.threadWindow.close': 'Cerrar ventana',
    'web.extras.diag.live': 'Conexión en vivo',
    'web.extras.diag.state': 'Estado',
    'web.extras.diag.lastEvent': 'Último evento',
    'web.extras.diag.events': 'Eventos recibidos',
    'web.extras.diag.conversation': 'Conversación abierta',
    'web.extras.diag.cached': 'Mensajes guardados',
    'web.extras.diag.lastMessage': 'Último mensaje',
    'web.extras.diag.reach': 'Historial',
    'web.extras.diag.reachStart': 'completo desde el inicio',
    'web.extras.diag.reachMore': 'hay mensajes más antiguos',
    'web.extras.diag.lastOpen': 'Última apertura',
    'web.extras.diag.openMs': 'Mensajes en pantalla',
    'web.extras.diag.noOpen': 'abre una conversación',
    'web.extras.diag.database': 'Base de datos',
    'web.extras.diag.storage': 'Almacenamiento',
    'web.extras.diag.storageOpfs': 'en el equipo (OPFS)',
    'web.extras.diag.storageMemory': 'solo en memoria',
    'web.extras.diag.probe': 'Lectura de prueba',
    'web.extras.diag.listReady': 'Lista lista en',
    'web.extras.diag.lastSync': 'Última sincronización',
    'web.extras.diag.outbox': 'Por enviar / fallidos',
    'web.extras.diag.resync': 'Forzar reconexión y recarga',
    'web.extras.diag.resyncing': 'Recargando…',
    'web.extras.diag.never': 'nunca',
    'web.extras.diag.now': 'ahora',
    'web.extras.diag.secondsAgo': 'hace %ds',
    'web.extras.diag.minutesAgo': 'hace %d min',
    'web.extras.diag.failed': 'FALLÓ',
    'web.extras.diag.ws.connected': 'conectado',
    'web.extras.diag.ws.connecting': 'conectando',
    'web.extras.diag.ws.authenticating': 'autenticando',
    'web.extras.diag.ws.reconnecting': 'reconectando',
    'web.extras.diag.ws.disconnected': 'DESCONECTADO',
    'web.extras.lowData.load': 'Cargar imagen',
  },
  en: {
    'web.extras.attention': 'You were mentioned',
    'web.extras.copyName': 'Copy name',
    'web.extras.nameCopied': 'Name copied',
    'web.extras.usernameCopied': '@username copied',
    'web.extras.tableCopied': 'Table copied',
    'web.extras.copyFailed': 'Could not copy.',
    'web.extras.threadWindow.blocked': 'The browser did not let the window open. Allow pop-ups for Satori Chat.',
    'web.extras.threadWindow.hostGone': 'The main Satori Chat window closed or reloaded. Close this window and open the thread again.',
    'web.extras.threadWindow.close': 'Close window',
    'web.extras.diag.live': 'Live connection',
    'web.extras.diag.state': 'State',
    'web.extras.diag.lastEvent': 'Last event',
    'web.extras.diag.events': 'Events received',
    'web.extras.diag.conversation': 'Open conversation',
    'web.extras.diag.cached': 'Messages stored',
    'web.extras.diag.lastMessage': 'Last message',
    'web.extras.diag.reach': 'History',
    'web.extras.diag.reachStart': 'complete from the start',
    'web.extras.diag.reachMore': 'older messages exist',
    'web.extras.diag.lastOpen': 'Last open',
    'web.extras.diag.openMs': 'Messages on screen',
    'web.extras.diag.noOpen': 'open a conversation',
    'web.extras.diag.database': 'Database',
    'web.extras.diag.storage': 'Storage',
    'web.extras.diag.storageOpfs': 'on this computer (OPFS)',
    'web.extras.diag.storageMemory': 'memory only',
    'web.extras.diag.probe': 'Test read',
    'web.extras.diag.listReady': 'List ready in',
    'web.extras.diag.lastSync': 'Last sync',
    'web.extras.diag.outbox': 'To send / failed',
    'web.extras.diag.resync': 'Force reconnect and reload',
    'web.extras.diag.resyncing': 'Reloading…',
    'web.extras.diag.never': 'never',
    'web.extras.diag.now': 'now',
    'web.extras.diag.secondsAgo': '%ds ago',
    'web.extras.diag.minutesAgo': '%d min ago',
    'web.extras.diag.failed': 'FAILED',
    'web.extras.diag.ws.connected': 'connected',
    'web.extras.diag.ws.connecting': 'connecting',
    'web.extras.diag.ws.authenticating': 'authenticating',
    'web.extras.diag.ws.reconnecting': 'reconnecting',
    'web.extras.diag.ws.disconnected': 'DISCONNECTED',
    'web.extras.lowData.load': 'Load picture',
  },
};
